{
  "(optional)": "(선택 사항)",
  "(required)": "(필수 사항)"
}
